<!-- mobile view -->
<ng-container *ngIf="(layout.isHandset$ | async); else desktopTemplate">
  <mat-toolbar color="primary"
               class="mobile toolbar-right">
    <button aria-label="back"
            *ngIf="layout.component !== 'company'"
            mat-icon-button
            class="toolbar-button"
            [routerLink]="['/company']">
      <mat-icon>domain</mat-icon>
    </button>
    <div *ngIf="(dataService.company$ | async)"
         class="companyInfo">
      <div>
        {{ (dataService.company$ | async)?.fancyName || (dataService.company$ | async)?.socialName }}
      </div>
      <div>
        {{ 'PROPERTY.COMPANY.CNPJ' | translate }}: <span>{{ (dataService.company$ | async)?.cnpj }}</span>
      </div>
    </div>

    <div class="flex-1"></div>
    <div *ngIf="(dataService.user$ | async)"
         class="justify-self-end">
      <button mat-icon-button
              *ngIf="(layout.isHandset$ | async)"
              aria-label="support"
              title="Fale conosco"
              (click)="layout.support()">
        <mat-icon svgIcon="whatsapp"></mat-icon>
      </button>
      <button aria-label="user"
              class="user-info"
              mat-button
              [matMenuTriggerFor]="userMenu">
        <mat-icon *ngIf="!(dataService.user$ | async).photo">account_circle</mat-icon>
        <img *ngIf="(dataService.user$ | async).photo"
             class="user-photo"
             [src]="(dataService.user$ | async).photo" />
        {{ (dataService.user$ | async).firstName }}
      </button>
      <mat-menu #userMenu>
        <a mat-menu-item
           [routerLink]="['user']">
          {{ 'label_user_info' | translate }}
        </a>
        <button mat-menu-item
                (click)="openUserPreferencesDialog()">
          Preferências
        </button>
        <button aria-label="logout"
                mat-menu-item
                (click)="signOut()">
          {{ 'label_logout' | translate }}
        </button>
      </mat-menu>
    </div>
  </mat-toolbar>
</ng-container>

<!-- desktop view -->
<ng-template #desktopTemplate>
  @if(dataService.user){
  @if(dataService.accessProfile$ | async | canAccess: 'NOTIFICATIONS.seeNotification') {
  <div class="tecinco-messages"
      [hidden]="isRobotPopupOpen"
      *ngIf="hasRobotMessages">
    <div class="avatar-alert">
      <img src="assets/images/Robo_.png"
           alt="Tecinco Robo"
           class="avatar-image"
           (click)="toggleT5MsgDropdown()">
      <div class="message-bubble">
        Temos novidades!
      </div>
      <div *ngIf="T5MsgMenuVisible"
           class="news-dropdown">
        <ng-container *ngFor="let campaignItem of eligibleCampaigns">
          <div class="news-item highlighted-news-item"
               [class.news-item-read]="isCampaignViewed(campaignItem)"
               (click)="openCampaignFromRobot(campaignItem)">
            <span class="news-badge">{{ getCampaignTypeLabel(campaignItem) }}</span>
            <h2>{{ getCampaignHeadline(campaignItem) }}</h2>
            <p>{{ getCampaignSummary(campaignItem) }}</p>
            <small>{{ (campaignItem.campaign?.publishedAt || campaignItem.campaign?.createdAt) | date:'mediumDate' }}</small>
          </div>
        </ng-container>
        <ng-container *ngFor="let item of T5Msgs">
          <div *ngIf="item.type !== 3 || (dataService.accessProfile$ | async | canAccess: 'NOTIFICATIONS.seeBillingNotifications')"
               class="news-item"
               [class.news-item-read]="item.messageStatus === 2"
               (click)="openT5MsgDialog(item)">
            <h2>{{ item.title }}</h2>
            <p>{{ item.description }}</p>
            <small>{{ item.createdAt | date:'mediumDate' }}</small>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  }
  }
  <mat-toolbar color="primary"
               class="toolbar">
    <button aria-label="back"
            *ngIf="['user', 'blocked'].includes(layout.component)"
            mat-icon-button
            class="toolbar-button"
            (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <button aria-label="toggle"
            *ngIf="(dataService.company$ | async) && (dataService.company$ | async)?.currentState != COMPANY_STATES.blocked"
            mat-icon-button
            class="toolbar-button"
            (click)="layout.toggleSidenav()">
      <mat-icon>menu</mat-icon>
    </button>

    <ng-container [ngSwitch]="APP_NAME">
      <img *ngSwitchCase="'Makeasy'"
           class="logo makena"
           src="/assets/images/makena_logos/MAKEASY.png"
           alt="Logo Makena" />
      <img *ngSwitchCase="'PO360'"
           class="logo PO360"
           src="assets/PO360/Logomarca/PNG/HORIZ. Claro Principal.png"
           alt="Logo PO360" />
      <img *ngSwitchCase="'MekanicAGRO'"
           class="logo agro"
           src="/assets/images/LogoMekanicAgro.png"
           alt="Logo MekanicWeb" />
      <img *ngSwitchCase="'MekanicNAVAL'"
           class="logo nautical"
           src="/assets/images/LogoMekanicNaval.png"
           alt="Logo MekanicWeb" />
      <img *ngSwitchDefault
           class="logo"
           src="/assets/images/LogoMekanicWeb.png"
           alt="Logo MekanicWeb" />
    </ng-container>

    @if(dataService.user && layout.component !== "company"){
    <button mat-icon-button
            [matMenuTriggerFor]="companies"><mat-icon>domain</mat-icon></button>
    <mat-menu #companies="matMenu"
              yPosition="below">
      @for(company of (dataService.user$ | async)?.ownCompanies$ | async; track $index){
        @if(company.currentState !== COMPANY_STATES.blocked){
          <button mat-menu-item
                  [disabled]="company.id === (dataService.company$ | async)?.id"
                  (click)="changeCompany(company)">
            <div>{{ company.fancyName }}</div>
            <small>{{ company.cnpj | document }}</small>
          </button>
          <mat-divider></mat-divider>
        }
      }
      @for(company of (dataService.user$ | async)?.linkedCompanies$ | async; track $index){
        @if(company.currentState !== COMPANY_STATES.blocked){
          <button mat-menu-item
                  [disabled]="company.id === (dataService.company$ | async)?.id"
                  (click)="changeCompany(company)">
            <div>{{ company.fancyName }}</div>
            <small>{{ company.cnpj | document }}</small>
          </button>
          <mat-divider></mat-divider>
        }
      }
    </mat-menu>
    }

    <div class="toolbar-right">

      <span class="companyInfo"
            *ngIf="(dataService.company$ | async)">
        <small>{{ (dataService.company$ | async)?.fancyName || (dataService.company$ | async)?.socialName }}</small>
        <small>
          {{ 'PROPERTY.COMPANY.CNPJ' | translate }}:
          <span>{{ (dataService.company$ | async)?.cnpj }}</span>
        </small>
      </span>


      @if(dataService.user){
        <button aria-label="messages"
                *ngIf="(dataService.company$ | async)?.currentState != COMPANY_STATES.blocked
              && (dataService.userRole$ | async) != roles.mechanic.id"
                mat-icon-button
                (click)="toggleMessages()">
          <mat-icon matBadgeColor="warn"
                    aria-hidden="false"
                    matBadgeDescription="unreaded messages"
                    [matBadge]="unread ? (unread < 99 ? unread : 99) : ''"> notifications </mat-icon>
        </button>
      }

      <div *ngIf="(dataService.user$ | async)">
        <button aria-label="user"
                class="user-info"
                mat-button
                [matMenuTriggerFor]="userMenu">
          <mat-icon *ngIf="!(dataService.user$ | async).photo">account_circle</mat-icon>
          <img *ngIf="(dataService.user$ | async).photo"
               class="user-photo"
               [src]="(dataService.user$ | async).photo" />
          {{ (dataService.user$ | async).firstName }}
        </button>
        <mat-menu #userMenu>
          <a mat-menu-item
             [routerLink]="['user']">
            {{ 'label_user_info' | translate }}
          </a>
          <button mat-menu-item
                  (click)="openUserPreferencesDialog()">
            Preferências
          </button>
          <button aria-label="logout"
                  mat-menu-item
                  (click)="signOut()">
            {{ 'label_logout' | translate }}
          </button>
        </mat-menu>
      </div>

    </div>

  </mat-toolbar>
</ng-template>

<mat-sidenav-container [ngClass]="{
    'sidenav-container': true,
    'mobile':(layout.isHandset$ | async),
    'desktop': !(layout.isHandset$ | async),
    'PO360': isPO360
  }"
  autosize>
  <!-- left sidenav -->
  <mat-sidenav *ngIf="!(layout.isHandset$ | async) && (dataService.company$ | async) && (dataService.company$ | async).currentState != COMPANY_STATES.blocked"
               #leftDrawer
               id="company-menu"
               [fixedTopGap]="50"
               [fixedBottomGap]="isPO360 ? 0 : 50"
               fixedInViewport="true"
               role="navigation"
               [mode]="'side'"
               [opened]="true"
               [disableClose]="true"
               position="start">
    @if ((dataService.company$ | async)?.newMenu === BOOLEAN_TWO.TRUE) {
      <mkg-new-aside-menu></mkg-new-aside-menu>
    } @else {
      <mkg-old-aside-menu></mkg-old-aside-menu>
    }
  </mat-sidenav>

  <mat-sidenav-content id="content"
                       [@routerTransition]="prepareRoute(o)">

    @if(isPO360){
      <p class="txt-center">A página <em>PO360</em> será descontinuada a partir de 04/10/2026, 
        continue utilizando o sistema através da página <em>MekanicWEB</em> 
        (<a href="http://web.mekanicgo.com.br/">https://web.mekanicgo.com.br/</a>).
      Para mais informações, contate a Tecinco: <a href="https://wa.me/5545999920045">(45)99992-0045</a> 
      </p>
    }


    <!-- <mat-sidenav-content id="content" [@routerTransition]="o.isActivated ? o.activatedRoute : ''"> -->
    <router-outlet #o="outlet"></router-outlet>
    <div *ngIf="(layout.isHandset$ | async)"
         class="mobileSpacer">
    </div>
  </mat-sidenav-content>

  <!-- right sidenav -->
  <mat-sidenav #rightDrawer
               [fixedTopGap]="50"
               fixedInViewport="true"
               mode="over"
               position="end">
    <app-sidenav [rightDrawer]="rightDrawer"
                 [messages]="messages"
                 [unread]="unread"></app-sidenav>
  </mat-sidenav>

</mat-sidenav-container>